import classnames from 'classnames2';
import React from 'react';

import styles from './HorizontalDivider.module.scss';

export interface IHorizontalDividerProps {
  /** The content for the divider */
  content?: string;
  /** Adds a CSS class to the divider element */
  className?: string;
}

export const HorizontalDivider: React.SFC<IHorizontalDividerProps> = ({ content, className }) => (
  <hr className={classnames(styles.divider, className)} data-content={content ?? ''} />
);
